export type Options = { [id: number]: Option; }
export class Option {
    
    title: string;
    value: string;

    constructor(title: string, value: string) {
        this.title = title;
        this.value = value;
    }
}

export enum OscillatorType {
    NA, XO, VCXO
}

export enum OperatingVoltage {
    NA, TwoPointFive, ThreePointThree
}

export enum Packaging {
    NA, Bulk, TapeReel
}

export enum RfOutputType {
    NA, LVCMOS, LVDS, LVPECL
}

export const rfOutputTypes: Options = {
    [RfOutputType.NA]: new Option("", ""),
    [RfOutputType.LVCMOS]: new Option("LVCMOS", "C"),
    [RfOutputType.LVPECL]: new Option("LVPECL", "P")
}

export const oscillatorTypes: Options = {
    [OscillatorType.NA]: new Option("", ""),
    [OscillatorType.XO]: new Option("Fixed", "X"),
    [OscillatorType.VCXO]: new Option("Adjustable", "V")
}

export const operatingVoltages: Options = {
    [OperatingVoltage.NA]: new Option("", ""),
    [OperatingVoltage.TwoPointFive]: new Option("2.5V", "B"),
    [OperatingVoltage.ThreePointThree]: new Option("3.3V", "A")
}

export const packagings: Options = {
    [OperatingVoltage.NA]: new Option("", ""),
    [Packaging.Bulk]: new Option("< 2,000 (Bulk)", "A"),
    [Packaging.TapeReel]: new Option("> 2,000 (Tape & Reel", "B")
}
